import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../../store';
import { addFeedback } from '../../../../actions/feedback';
import { CommentForm } from './CommentForm';

export const CommentFormContainer = connect(
  (state: IState) => ({
    formStatus: state.feedback.status,
  }),
  (dispatch: Dispatch<{}>) => ({
    onClick(comment: string) {
      dispatch(addFeedback(comment));
    },
  }),
)(CommentForm);
